/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export const contentError = "ContentError";
export const userSwitch = "user_switch";
